import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const UserInvoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [selectedPO, setSelectedPO] = useState(null);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [formData, setFormData] = useState({
    purchaseOrderId: '',
    dueDate: '',
    notes: ''
  });

  useEffect(() => {
    fetchInvoices();
    fetchPurchaseOrders();
  }, []);

  const fetchInvoices = async () => {
    try {
      const res = await axios.get('/api/invoices');
      setInvoices(res.data);
    } catch (error) {
      console.error('Error fetching invoices:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPurchaseOrders = async () => {
    try {
      const res = await axios.get('/api/purchase-orders');
      // Filter POs that don't have invoices yet
      const posWithoutInvoices = res.data.filter(po => !po.invoiceId && po.status === 'sent');
      setPurchaseOrders(posWithoutInvoices);
    } catch (error) {
      console.error('Error fetching purchase orders:', error);
    }
  };

  const handleCreateInvoice = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/invoices/create', formData);
      setShowCreateForm(false);
      setFormData({ purchaseOrderId: '', dueDate: '', notes: '' });
      fetchInvoices();
      fetchPurchaseOrders();
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to create invoice');
    }
  };

  const getStatusBadge = (status) => {
    const statusClass = `badge badge-${status.toLowerCase().replace(' ', '-')}`;
    return <span className={statusClass}>{status}</span>;
  };

  if (loading) {
    return <div className="loading">Loading invoices...</div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>Invoices</h2>
        {purchaseOrders.length > 0 && (
          <button className="btn btn-primary" onClick={() => setShowCreateForm(true)}>
            Create Invoice
          </button>
        )}
      </div>

      {showCreateForm && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <h3>Create Invoice</h3>
          <form onSubmit={handleCreateInvoice}>
            <div className="form-group">
              <label>Purchase Order *</label>
              <select
                value={formData.purchaseOrderId}
                onChange={(e) => setFormData({ ...formData, purchaseOrderId: e.target.value })}
                required
              >
                <option value="">Select Purchase Order</option>
                {purchaseOrders.map(po => (
                  <option key={po._id} value={po._id}>
                    {po.poNumber} - ${po.totalAmount}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Due Date</label>
              <input
                type="date"
                value={formData.dueDate}
                onChange={(e) => setFormData({ ...formData, dueDate: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Notes</label>
              <textarea
                value={formData.notes}
                onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
              />
            </div>
            <button type="submit" className="btn btn-success">Create Invoice</button>
            <button type="button" className="btn btn-secondary" onClick={() => setShowCreateForm(false)} style={{ marginLeft: '10px' }}>
              Cancel
            </button>
          </form>
        </div>
      )}

      {invoices.length === 0 ? (
        <div className="card">
          <p>No invoices found.</p>
        </div>
      ) : (
        <div>
          {invoices.map(invoice => (
            <div key={invoice._id} className="card">
              <h3>Invoice Number: {invoice.invoiceNumber}</h3>
              <p><strong>Status:</strong> {getStatusBadge(invoice.status)}</p>
              <p><strong>Total Amount:</strong> ${invoice.totalAmount}</p>
              <p><strong>PO Number:</strong> {invoice.purchaseOrderId?.poNumber}</p>
              {invoice.dueDate && <p><strong>Due Date:</strong> {new Date(invoice.dueDate).toLocaleDateString()}</p>}
              <p><strong>Issued At:</strong> {new Date(invoice.issuedAt).toLocaleString()}</p>
              {invoice.notes && <p><strong>Notes:</strong> {invoice.notes}</p>}
              <div style={{ marginTop: '15px' }}>
                <h4>Associated Routes:</h4>
                <ul>
                  {invoice.routes.map(route => (
                    <li key={route._id}>
                      {route.routeNumber} - {route.startPoint} to {route.endPoint} (${route.price})
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UserInvoices;
